import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'rlst-annotation-window',
  templateUrl: './annotation-window.component.html',
  styleUrls: ['./annotation-window.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnnotationWindowComponent implements OnInit {
  public MAX_LENGTH: number = 100;
  public charactersLeft: number = 0;
  public isFocused: boolean = false;
  public annotation: UntypedFormControl = new UntypedFormControl('');
  private timerId: any;

  @Output() deleteAnnotation: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.annotation.valueChanges
      .pipe(
        startWith(this.annotation.value),
        untilDestroyed(this),
        map((str: string) => str.length)
      )
      .subscribe((length: number) => {
        this.charactersLeft = this.MAX_LENGTH - length;
        this.cdr.detectChanges();
      });
  }

  public focusHandler(): void {
    clearTimeout(this.timerId);
    this.isFocused = true;
  }

  public blurHandler(): void {
    this.timerId = setTimeout(() => {
      this.isFocused = false;
      this.cdr.markForCheck();
      // eslint-disable-next-line no-magic-numbers
    }, 500);
  }
}
